var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("研究成果")]),_vm._l((_vm.works),function(work){return _c('div',[_c('h3',[_vm._v(_vm._s(work.title)+"年")]),_c('ul',{staticClass:"object",attrs:{"name":"work"},domProps:{"innerHTML":_vm._s(work.text)}})])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }